<template>
  <div class="notice-history">
    <div class="ajie_table" v-if="noticeList.length">
      <el-table :data="noticeList" border v-loading="loading">
        <el-table-column prop="noticeId" label="消息编号" width="100"></el-table-column>
        <el-table-column prop="noticeContent" label="消息内容"></el-table-column>
        <el-table-column prop="createTime" label="发送时间" width="150" :formatter="timeFormat"></el-table-column>
      </el-table>

      <el-pagination
        v-if="page.total > page.pageRows"
        background
        layout="total, prev, pager, next, jumper"
        :total="page.total"
        :page-size="page.pageRows"
        :current-page="page.index"
        @current-change="pageChange">
      </el-pagination>
    </div>

    <Nothing v-if="!noticeList.length && !loading"></Nothing>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';

  export default {
    data(){
      return {
        noticeList: [], // 通知列表
        page:{
          total: 0, // 总条数
          pageRows: 20, // 每页条数
          index: 1, // 页码
        },
        loading: true, // 表格加载中
      }
    },
    computed: {
      ...mapGetters(['token']),
    },
    methods: {
      getNoticeList(){
        this.loading = true
        this.$http.post(`${this.URL_PREFIX}/app/get/user/notice/history/list`, {
          currPage:this.page.index,
          pageRows: this.page.pageRows
        }, {
          headers: { token: this.token }
        }).then((response) => {
          if(response.data.resCode == '10000'){
            this.loading = false
            let resDate = response.data.resData;
            this.noticeList = resDate.pageList
            this.page = Object.assign(this.page, resDate.pageInfo)
          }
        });
      },
      timeFormat(row, column, cellValue){
        let dateFilter = Vue.filter('DateFilter')
        return dateFilter(cellValue, 'yyyy-MM-dd hh:mm:ss');
      },
      pageChange(page){
        this.page.index = page
        this.getNoticeList()
      }
    },
    mounted(){
      this.getNoticeList()
    }
  }
</script>

<style lang="scss" scoped>
  @import "~@scss";
  .notice-history{
    background-color: #fff;
    .ajie_table{
      padding: 20px;
      font-size: 12px;
      background-color: #fff;
      .el-table{
        font-size: 12px;
        .el-button{
          color: #333;
          font-weight: normal;
          &.title {
            width: 400px;
          }
          &:hover{
            text-decoration: underline;
          }
        }
      }

      .el-pagination{
        margin-top: 20px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/navigator/personal/components/info/NoticeHistory.vue